module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"Su":"日","Mo":"月","Tu":"火","We":"水","Th":"木","Fr":"金","Sa":"土"}}')
  delete Component.options._Ctor
}
